import { Injectable } from '@angular/core';
import { SocketService } from '@frontend/common/util';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import {
  GlobalCreateLocationSuccessWs,
  GlobalRemoveLocationSuccessWs,
  GlobalUpdateLocationStatusSuccessWs,
  GlobalUpdateLocationSuccessWs,
  LocalCreateLocationFailureWs,
  LocalCreateLocationSuccessWs,
  LocalRemoveLocationFailureWs,
  LocalRemoveLocationSuccessWs,
  LocalUpdateLocationFailureWs,
  LocalUpdateLocationSuccessWs,
} from './location-ws.actions';

@Injectable()
export class LocationWsEffects {
  LocalCreateLocationSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('locations.create')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalCreateLocationSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalCreateLocationFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('locations.create')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalCreateLocationFailureWs({ correlation_id, message })
        )
      )
  );

  LocalUpdateLocationSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('locations.update')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalUpdateLocationSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalUpdateLocationFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('locations.update')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalUpdateLocationFailureWs({ correlation_id, message })
        )
      )
  );

  LocalRemoveLocationSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('locations.remove')
      .pipe(
        map(({ correlation_id }) => new LocalRemoveLocationSuccessWs({ correlation_id }))
      )
  );

  LocalRemoveLocationFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('locations.remove')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalRemoveLocationFailureWs({ correlation_id, message })
        )
      )
  );

  GlobalCreateLocationSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('locations.create')
      .pipe(map((location: any) => new GlobalCreateLocationSuccessWs(location)))
  );

  GlobalUpdateLocationSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('locations.update')
      .pipe(map((location: any) => new GlobalUpdateLocationSuccessWs(location)))
  );

  GlobalRemoveLocationSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('locations.remove')
      .pipe(map(({ id }: any) => new GlobalRemoveLocationSuccessWs(id)))
  );

  GlobalStatusUpdateLocationSuccessWs$ = createEffect(() =>
    this.socketSrv.fromGlobalSuccess('locations.update-status').pipe(
      map(
        (location: any) =>
          new GlobalUpdateLocationStatusSuccessWs({
            location,
          })
      )
    )
  );

  constructor(private socketSrv: SocketService) {}
}
